import "@fontsource-variable/inter";
import "@/styles/globals.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";

import { Toaster } from "@/components/feedback/toaster";
import { ApiError } from "@/lib/api";
import { router } from "@/routes";
import { ScopeProvider } from "@/state/scope";
import { ThemeProvider } from "@/state/theme";
import { ToastProvider } from "@/state/toast";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => failureCount < 2 && !(error instanceof ApiError && error.status < 500),
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ScopeProvider>
          <ToastProvider>
            <RouterProvider router={router} />
            <Toaster />
          </ToastProvider>
        </ScopeProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
